import { useEffect, useMemo } from 'react';

import { useInView } from 'react-intersection-observer';

import {
  useCrossdockingContext,
  useGetToReceiveCrossdockingOrders,
} from '../../application/hooks';

import { LoadingMoreOrders } from '../../../components';
import {
  Layout,
  SkeletonCard,
  CrossdockingOrderCard,
  NoIncompleteOrders,
} from '../components/toReceiveCrossdocking';

export default function CrossdockingIncompleteTab() {
  const { filters: crossdockingFilters } = useCrossdockingContext();
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: '100px',
  });

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetToReceiveCrossdockingOrders({
      ...crossdockingFilters,
      status: 'incomplete',
    });

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

  const pendingOrders = useMemo(
    () => data?.pages?.flatMap((page) => page?.data?.orders) ?? [],
    [data]
  );

  if (isLoading) {
    return (
      <Layout isLoadingLayout={isLoading}>
        {Array.from({ length: 5 }).map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </Layout>
    );
  }

  if (pendingOrders.length === 0 && !isLoading) {
    return (
      <Layout isLoadingLayout={isLoading}>
        <NoIncompleteOrders />
      </Layout>
    );
  }

  return (
    <Layout isLoadingLayout={isLoading}>
      {pendingOrders.map((order) => (
        <CrossdockingOrderCard
          key={order.id_order}
          order={order}
          isIncomplete
        />
      ))}

      {hasNextPage && !isFetchingNextPage && (
        <LoadingMoreOrders reference={ref} />
      )}
    </Layout>
  );
}
